<template>
  <a
    tabindex="0"
    title="back2Top"
    id="back2Top"
    @keyup.enter="onEnter"
    @click="scrollTop()"
    class="is-pulled-right os-scroll-btn"
  >
    <font-awesome-icon :icon="['fas', 'chevron-up']" />
    {{ $t("message.scroll_btn") }}
  </a>
</template>

<script>
export default {
  name: "ButtonScroll",
  methods: {
    scrollTop() {
      window.scrollTo(0, top);
    },
    onEnter(event) {
      if (event) {
        document.getElementById(event.target.id).click()
      }
    }
  } // end methods
};
</script>

<style lang="scss">
.os-scroll-btn {
  position: relative;
  padding: 12px;
}
</style>
